import { db } from '../firebase/firebaseConfig';
import { ref, update } from 'firebase/database';

const API_ENDPOINTS = {
    GitHub: "https://api.github.com/zen", // Lightweight endpoint
    LeetCode: "https://leetcode-api-faisalshohag.vercel.app/faisalshohag", // Ping a known user
    Codeforces: "https://codeforces.com/api/user.info?handles=Tourist" // Ping a known top user
};

export const runFullDiagnostic = async () => {
    const healthResults = {
        lastChecked: Date.now(),
        services: {}
    };

    const checkService = async (name, url) => {
        const start = performance.now();
        try {
            const response = await fetch(url, { cache: 'no-store' });
            const end = performance.now();
            const latency = Math.round(end - start);

            if (response.ok) {
                return { status: 'healthy', latency: `${latency}ms`, timestamp: Date.now() };
            } else {
                return { status: 'degraded', latency: `${latency}ms`, timestamp: Date.now(), error: response.statusText };
            }
        } catch (err) {
            const end = performance.now();
            return { status: 'offline', latency: `${Math.round(end - start)}ms`, timestamp: Date.now(), error: err.message };
        }
    };

    // Run checks in parallel
    const names = Object.keys(API_ENDPOINTS);
    const results = await Promise.all(names.map(name => checkService(name, API_ENDPOINTS[name])));

    names.forEach((name, index) => {
        healthResults.services[name] = results[index];
    });

    // Save to Firebase
    try {
        await update(ref(db, 'stats/api_health'), healthResults);
        return healthResults;
    } catch (err) {
        console.error("Failed to save health diagnostic", err);
        throw err;
    }
};
